export const defaultIframeStyles: Partial<CSSStyleDeclaration> = {
  border: 'none',
  boxSizing: 'border-box',
  zIndex: '99999',
  width: '100%',
  height: '100%',
};

const normalStyles: Partial<CSSStyleDeclaration> = {
  position: 'relative',
  width: '100%',
  height: '100%',
};

export const getNormalStyles = (): Partial<CSSStyleDeclaration> => normalStyles;

const fullscreenStyles: Partial<CSSStyleDeclaration> = {
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100vw',
  height: '100%',
  zIndex: '999999',
};

export const getFullscreenStyles = (): Partial<CSSStyleDeclaration> => fullscreenStyles;
